import ContentLayout from '@/layouts/content-layout'
import BannersView from '@/sections/banners/view/banners-view'

export default function BannersPage() {
  return (
    <ContentLayout title="แบนเนอร์">
      <BannersView />
    </ContentLayout>
  )
}
